export enum InteractionRefType {
    Sponsor = "sponsor",
    Ad = "ad",
    Merchant = "merchant",
    Offer = "offer",
    ZipCode = "zip_code",
    GPS = "gps"
}
